import { AdUnitRefresherDTO } from 'features/inventory/api/types/adUnitRefresherDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const AD_UNIT_REFRESHER_FRAGMENT: TypedDocumentNode<AdUnitRefresherDTO> = gql`
  fragment AdUnitRefresherFragment on AdUnitRefresher {
    adUnitId
    customizeRefresherBasicSettingsEnabled
    desktopAdThreshold
    desktopMonitorUserScrollEnabled
    desktopRefreshInterval
    externalAdUnitPath
    id
    mobileAdThreshold
    mobileMonitorUserScrollEnabled
    mobileRefreshInterval
    refresherEnabled
    sendRefreshRequestToExternalAdUnitEnabled
    sizes
    updatedAt
    mediaTypeRefreshers {
      defaultAttribute {
        additionalSizes
        id
        removeSizes
        updatedAt
      }
      ignoreViewportRefresherAttributes
      viewportAttributes {
        additionalSizes
        id
        removeSizes
        updatedAt
        viewport {
          id
          minimumWidth
          name
        }
      }
    }
  }
`
